export default __webpack_public_path__ + "static/media/downloadIconPdftron.8466bc81.svg";